// extracted by mini-css-extract-plugin
export default {"container":"style_container__bvGkm","slider":"style_slider__X-Gj5","hallPicture":"style_hallPicture__fBRTX","hallTitle":"style_hallTitle__2OjA1"};